import React from 'react';
// @ts-ignore
import BasicEchart from './components/BasicEchart';
import PieEchart from './components/PieEchart';
import BarEchart from './components/BarEchart';
import EventTypeEchart from './components/EventTypeEchart';

const LineEchart = (props: any) => (<BarEchart {...props} type="line" />);

export {
  BasicEchart,
  PieEchart,
  BarEchart,
  LineEchart,
  EventTypeEchart,
}
